import {useResponsivePropValue} from 'platform/foundation';

import type {EntityHeaderActionsProps} from '../types';
import {getResponsiveActions} from '../utils/getResponsiveActions';

export function useResponsiveActions(
  props: Pick<EntityHeaderActionsProps, 'actions' | 'maxVisibleActions' | 'dropdownPosition'>
) {
  const maxVisibleActions = useResponsivePropValue(props.maxVisibleActions);
  const dropdownPosition = useResponsivePropValue(props.dropdownPosition);

  const responsiveActions = maxVisibleActions
    ? getResponsiveActions(props?.actions ?? [], maxVisibleActions, dropdownPosition)
    : props.actions;

  return {responsiveActions};
}
